import React, {memo} from 'react';
import styled from 'styled-components';

import {greys, palette} from '../../../../libs/shared/ui/src/styles/colorStyles';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface TextAreaCounterProps {
  textLength: number;
  textLengthLimit: number;
}

/*
 * Style.
 */

const StyledCounterDiv = styled.div`
  font-variant-numeric: tabular-nums;
  float: right;
  display: inline-flex;
  position: absolute;
  right: 12px;
  bottom: 24px;
`;

interface PillStyleProps {
  $isOverLimit: boolean;
}

const StyledPillDiv = styled.div<PillStyleProps>`
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
  border-radius: 4px;
  padding: 2px 4px;
  height: 18px;
  color: ${(p) => (p.$isOverLimit ? palette.red.shade40 : greys.shade80)};
  background-color: ${(p) => (p.$isOverLimit ? palette.red.shade20 : greys.shade30)};
`;

/*
 * Component.
 */

export const TextAreaCounter = memo<TextAreaCounterProps>((props) => {
  const {textLength, textLengthLimit} = props;

  const isOverLimit = textLength > textLengthLimit;
  const remainingCharacters = textLengthLimit - textLength;
  // Limit the counter to -999 to avoid the pill growing wider/covering more of the text
  // (in the rare case someone really gets to ranting in some feedback ...)
  const countText = remainingCharacters < -999 ? '-999+' : remainingCharacters;

  return (
    <StyledCounterDiv>
      <StyledPillDiv $isOverLimit={isOverLimit}>{countText}</StyledPillDiv>
    </StyledCounterDiv>
  );
});
